import PartyWebworker from "@/services/party.worker";

export class PartyService {
  partyWebworker;

  constructor() {
    this.partyWebworker = new PartyWebworker();
  }

  onmessage(cb) {
    this.partyWebworker.onmessage = e => {
      cb(e);
    };
  }

  postMessage(type, data = {}) {
    this.partyWebworker.postMessage({
      type,
      data
    });
  }

  startHandleMessage() {
    this.postMessage("startHandleMessage");
  }

  initPartyList(data) {
    this.postMessage("initPartyList", data);
  }

  callOutParty(data) {
    this.postMessage("callOutParty", data);
  }

  modifyPartyInfo(data) {
    this.postMessage("modifyPartyInfo", data);
  }

  updatePartyRole(data) {
    this.postMessage("updatePartyRole", data);
  }

  deleteParty(data) {
    this.postMessage("deleteParty", data);
  }

  partyMessage(data) {
    this.postMessage("partyMessage", data);
  }
}
